









import axios from "axios";
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      logoImageData: "" as string,
      title: "" as string,
    };
  },
  mounted() {
    this.fetchLogoImageData();
    this.fetchTitle();
  },
  methods: {
    fetchLogoImageData(): void {
      axios
        .get("../REST/loginconfig/config/company/logo/data", {
          responseType: "blob",
        })
        .then((response) => {
          // Create a Blob object from the received image data
          const blob: Blob = new Blob([response.data], { type: "image/png" });

          // Create a URL for the Blob object
          const imageUrl: string = URL.createObjectURL(blob);

          // Set the logo image data URL as the source for the logo image
          this.logoImageData = imageUrl;
        })
        .catch((error) => {
          console.error("Error fetching logo image data:", error);

          // If there's an error fetching the logo, set the default logo from window.config.defaultLogoUrl
          this.logoImageData = window.config.defaultLogoUrl;
        });
    },
    fetchTitle(): void {
      axios
        .get<string>("../REST/loginconfig/config/company/title")
        .then((response) => {
          this.title = response.data;
        })
        .catch((error) => {
          console.error("Error fetching title:", error);

          // If there's an error fetching the title, set the default title from window.config.title
          this.title = window.config.title;
        });
    },
  },
});
